export default __webpack_public_path__ + "static/media/Ballroll_00157.16109988.png";